import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./globals.css";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://5d6d73d68039797b249643084ff6e27f@o4504190596218880.ingest.us.sentry.io/4509295550136320",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
